import GetLoading from "../../share/getLoading";

// // import React, { useState } from "react";
// // import { LockOutlined, UserOutlined } from "@ant-design/icons";
// // import { Button, Form, Input, message, Card, Typography } from "antd";
// 
// // import { useNavigate } from "react-router-dom";
// // import { request } from "../../share/request";

// // // Assuming you have a CSS file for these custom styles
// // import "../../styles/Home-module.css"; 

// // const { Title, Text } = Typography;

// // function LoginPage() {
// //   const navigate = useNavigate();
// //   const [usernameInput, setUsername] = useState("");
// //   const [passwordInput, setPassword] = useState("");
// //   const [loading, setLoading] = useState(false);

// //   const onFinish = async (values) => {
// //     setLoading(true);
// //     const param = {
// //       username: usernameInput,
// //       password: passwordInput,
// //     };

// //     try {
// //       const res = await request("user/login", "post", param);
// //       if (res.isSuccess) {
// //         if (res.profileData.islogin !== 0) {
// //           await new Promise((resolve) => setTimeout(resolve, 600));
// //           localStorage.setItem("profile", JSON.stringify(res.profileData));
// //           localStorage.setItem("profileOrgData", JSON.stringify(res.profileOrgData));

// //           const encodedPermission = btoa(JSON.stringify(res.permission));
// //           localStorage.setItem("per_option", encodedPermission);
// //           localStorage.setItem("token", JSON.stringify(res.access_token));
// //           localStorage.setItem("isLogin", "1");
// //           window.location.href = "/";
// //         } else {
// //           window.location.href = `/forgot-password?visableinput=${true}&phone=${encodeURIComponent(usernameInput)}`;
// //         }
// //       } else {
// //         message.error(res.message || "Login Failed");
// //       }
// //     } catch (error) {
// //       message.error("An error occurred. Please try again.");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   return (
// //     <div style={styles.pageWrapper}>
// //       {/* Loading Overlay */}
// //       {loading && (
// //         <div style={styles.loaderOverlay}>
// //           <GetLoading />
// //         </div>
// //       )}

// //       <Card style={styles.loginCard} bordered={true}>
// //         <div style={styles.headerSection}>
// //           <img
// //             src= "https://datacenterapi.votmean.app/photo/hmis_staff/file_image_logo-1763183005047-108934296"
// //              alt="logo"
// //             style={styles.logo}
// //           />
// //           <Title level={3} style={styles.khmerTitle}>
// //             ប្រព័ន្ធគ្រប់គ្រងរដ្ឋបាល
// //           </Title>
// //           {/* <Text type="secondary">សូមបញ្ចូលគណនីរបស់អ្នកដើម្បីចូលប្រើប្រាស់</Text> */}
// //         </div>

// //         <Form
// //           name="login_form"
// //           layout="vertical"
// //           onFinish={onFinish}
// //           style={{ marginTop: 24 }}
// //         >
// //           <Form.Item
// //             name="username"
// //             rules={[{ required: true, message: "សូមបញ្ចូលឈ្មោះអ្នកប្រើប្រាស់!" }]}
// //           >
// //             <Input
// //               size="large"
// //               placeholder="Username / Phone Number"
// //               prefix={<UserOutlined style={{ color: "#bfbfbf" }} />}
// //               onChange={(e) => setUsername(e.target.value)}
// //               style={styles.inputRound}
// //             />
// //           </Form.Item>

// //           <Form.Item
// //             name="password"
// //             rules={[{ required: true, message: "សូមបញ្ចូលលេខសម្ងាត់!" }]}
// //           >
// //             <Input.Password
// //               size="large"
// //               placeholder="Password"
// //               prefix={<LockOutlined style={{ color: "#bfbfbf" }} />}
// //               onChange={(e) => setPassword(e.target.value)}
// //               style={styles.inputRound}
// //             />
// //           </Form.Item>

// //           <div style={styles.forgotWrapper}>
// //             <Text 
// //               onClick={() => navigate("/forgot-password")} 
// //               style={styles.forgotText}
// //             >
// //               ភ្លេចលេខសម្ងាត់?
// //             </Text>
// //           </div>

// //           <Form.Item>
// //             <Button
// //               type="primary"
// //               htmlType="submit"
// //               size="large"
// //               block
// //               style={styles.loginBtn}
// //             >
// //               ចូលប្រើប្រាស់ (Log in)
// //             </Button>
// //           </Form.Item>
// //         </Form>

// //         <div style={styles.footer}>
// //           <Text style={{ fontSize: 12, color: "#bfbfbf" }}>
// //             © 2026 Votmean Management System
// //           </Text>
// //         </div>
// //       </Card>
// //     </div>
// //   );
// // }

// // // Inline Styles for "Clean & Beautiful" UI
// // const styles = {
// //   pageWrapper: {
// //     display: "flex",
// //     justifyContent: "center",
// //     alignItems: "center",


// //     padding: "20px",
// //   },
// //   loaderOverlay: {
// //     position: "fixed",
// //     top: 0,
// //     left: 0,
// //     width: "100%",
// //     height: "100%",
// //     backgroundColor: "rgba(255, 255, 255, 0.7)",
// //     display: "flex",
// //     justifyContent: "center",
// //     alignItems: "center",
// //     zIndex: 1000,
// //   },
// // loginCard: {
// //     // This is the updated gradient background

// //    // background: "linear-gradient(180deg, #f4f8ffff 0%, #073c9fff 100%)",
// //     width: "100%",
// //     borderwidth: "1px",
// //     maxWidth: "420px",
// //     borderRadius: "16px",
// //     boxShadow: "0 10px 25px rgba(0,0,0,0.1)", // Slightly deeper shadow for contrast
// //     padding: "30px 20px", // More internal breathing room

// //     border: "1px solid rgba(255, 255, 255, 0.96)", // Glass-like edge
// //   },
// //   headerSection: {
// //     textAlign: "center",
// //   },
// //   logo: {
// //     borderRadius:60,
// //     height: "120px",
// //     marginBottom: "16px",
// //     filter: "drop-shadow(0px 4px 4px rgba(0,0,0,0.1))",
// //   },
// //   khmerTitle: {
// //     fontFamily: "'Content', sans-serif",
// //     color: "#1e8449",
// //     margin: "0 0 8px 0",
// //     fontWeight: "700",
// //   },
// //   inputRound: {
// //     borderRadius: "8px",
// //   },
// //   forgotWrapper: {
// //     textAlign: "right",
// //     marginBottom: "20px",
// //   },
// //   forgotText: {
// //     color: "#943126",
// //     cursor: "pointer",
// //     fontSize: "13px",
// //     fontFamily: "'Content', sans-serif",
// //   },
// //   loginBtn: {
// //     height: "48px",
// //     borderRadius: "8px",
// //     fontSize: "16px",
// //     fontWeight: "600",
// //     backgroundColor: "#1e8449",
// //     border: "none",
// //     boxShadow: "0 4px 12px rgba(30, 132, 73, 0.2)",
// //   },
// //   footer: {
// //     textAlign: "center",
// //     marginTop: "20px",
// //   }
// // };

// // export default LoginPage;



// import React, { useState } from "react";
// import { LockOutlined, UserOutlined, CheckCircleFilled } from "@ant-design/icons";
// import { Button, Form, Input, Typography } from "antd";

// import { useNavigate } from "react-router-dom";
// import { request } from "../../share/request";
// import { openNotification } from "../../share/message"; 

// import "../../styles/Home-module.css"; 
// import styles from "./LoginPage.module.css"; 

// const { Title, Text } = Typography;

// function LoginPage() {
//   const navigate = useNavigate();
//   const [usernameInput, setUsername] = useState("");
//   const [passwordInput, setPassword] = useState("");
//   const [loading, setLoading] = useState(false);

//   const onFinish = async (values) => {
//     setLoading(true);
//     const param = {
//       username: usernameInput,
//       password: passwordInput,
//     };

//     try {
//       const res = await request("user/login", "post", param);
//       if (res.isSuccess) {
//         if (res.profileData.islogin !== 0) {
//           await new Promise((resolve) => setTimeout(resolve, 600));
//           localStorage.setItem("profile", JSON.stringify(res.profileData));
//           localStorage.setItem("profileOrgData", JSON.stringify(res.profileOrgData));

//           const encodedPermission = btoa(JSON.stringify(res.permission));
//           localStorage.setItem("per_option", encodedPermission);
//           // store raw token string (do not JSON.stringify to avoid surrounding quotes)
//           localStorage.setItem("token", res.access_token);
//           localStorage.setItem("isLogin", "1");
//           window.location.href = "/";
//         } else {
//           openNotification("error", "គណនីរបស់អ្នកត្រូវបានចាក់សោរ / Account Locked");
//         }
//       } else {
//         openNotification("error", res.message || "ឈ្មោះអ្នកប្រើប្រាស់ ឬ លេខសម្ងាត់មិនត្រឹមត្រូវ");
//       }
//     } catch (error) {
//       openNotification("error", "មានបញ្ហាតភ្ជាប់ទៅកាន់ប្រព័ន្ធ / Connection Error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className={styles.loginWrapper}>
//       {loading && (
//         <div className={styles.loadingOverlay}>
//           <GetLoading />
//         </div>
//       )}

//       <div className={styles.loginContainer}>
//         {/* COLUMN 1: Details & Features Info */}
//         <div className={styles.detailsColumn}>
//           <div className={styles.brandHeader}>
//             <img
//               src="https://datacenterapi.votmean.app/photo/hmis_staff/file_image_logo-1763183005047-108934296"
//               alt="Logo"
//               className={styles.infoLogo}
//             />
//             <div>
//               <Title level={2} className={styles.infoMainTitle}>វត្តមាន Votmean</Title>
//               <Text className={styles.infoSubTitle}>VOTMEAN APP MANAGEMENT SYSTEM</Text>
//             </div>
//           </div>

//           <div className={styles.featureList}>
//             <Title level={4} className={styles.featureSectionTitle}>
//               មុខងារ និងការគ្រប់គ្រងប្រព័ន្ធលម្អិត
//             </Title>

//             <div className={styles.featureItem}>
//               <CheckCircleFilled className={styles.featureIcon} />
//               <div>
//                 <Text className={styles.featureTitle}>គ្រប់គ្រងតាមអង្គភាពនីមួយៗ</Text>
//                 <Text className={styles.featureDesc}>រៀបចំរចនាសម្ព័ន្ធ កំណត់តួនាទី និងសិទ្ធិប្រើប្រាស់ទៅតាមនាយកដ្ឋាន ឬផ្នែកនីមួយៗដាច់ដោយឡែក ប្រកបដោយសុវត្ថិភាព។</Text>
//               </div>
//             </div>

//             <div className={styles.featureItem}>
//               <CheckCircleFilled className={styles.featureIcon} />
//               <div>
//                 <Text className={styles.featureTitle}>ស្រង់វត្តមានបុគ្គលិកឆ្លាតវៃ</Text>
//                 <Text className={styles.featureDesc}>កត់ត្រាទិន្នន័យវត្តមាន ម៉ោងចូល និងម៉ោងចេញយ៉ាងត្រឹមត្រូវរហ័ស ទប់ស្កាត់ការក្លែងបន្លំទិន្នន័យ។</Text>
//               </div>
//             </div>

//             <div className={styles.featureItem}>
//               <CheckCircleFilled className={styles.featureIcon} />
//               <div>
//                 <Text className={styles.featureTitle}>របាយការណ៍តាម Web App & Phone</Text>
//                 <Text className={styles.featureDesc}>ពិនិត្យមើល និងទាញយករបាយការណ៍វត្តមាន និងស្ថិតិផ្សេងៗបានទាន់ពេលវេលា (Real-time) ទាំងនៅលើកុំព្យូទ័រ និងទូរស័ព្ទដៃ។</Text>
//               </div>
//             </div>

//             <div className={styles.featureItem}>
//               <CheckCircleFilled className={styles.featureIcon} />
//               <div>
//                 <Text className={styles.featureTitle}>គ្រប់គ្រងការចុះបេសកកម្ម និងច្បាប់ឈប់សម្រាក</Text>
//                 <Text className={styles.featureDesc}>ស្នើសុំ និងអនុម័តច្បាប់ឈប់សម្រាក (Leave Request) ឬលិខិតបញ្ជាបេសកកម្មផ្សេងៗតាមរយៈប្រព័ន្ធឌីជីថលទំនើប។</Text>
//               </div>
//             </div>
//                 <div className={styles.featureItem}>
//               <CheckCircleFilled className={styles.featureIcon} />
//               <div>
//                 <Text className={styles.featureTitle}>មុខងារកំណត់សិទ្ធអ្នកប្រើប្រាស់</Text>
//                 <Text className={styles.featureDesc}>ប្រព័ន្ធគ្រប់គ្រងសិទ្ធអ្នកប្រើប្រាស់ដូចការ  បង្កើត កែប្រែ លុប </Text>
//               </div>
//             </div>
//                <div className={styles.featureItem}>
//               <CheckCircleFilled className={styles.featureIcon} />
//               <div>
//                 <Text className={styles.featureTitle}>កំណត់មុខងារផ្សេងៗ</Text>
//                 <Text className={styles.featureDesc}> ប្រព័ន្ធគ្រប់គ្រងការ ផ្ញើរសារទៅកាន់ Mobile App WebApp Telegram..   </Text>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* COLUMN 2: Clean Form Sign In */}
//         <div className={styles.formColumn}>
//           <div className={styles.formHeaderSection}>
//             <Title level={3} className={styles.khmerTitle}>
//               ស្វាគមន៍មកកាន់ប្រព័ន្ធ
//             </Title>
//             <Text className={styles.formSubTitle}>
//               សូមបញ្ចូលគណនីរបស់អ្នកដើម្បីចូលប្រើប្រាស់
//             </Text>
//           </div>

//           <Form
//             name="login_form"
//             className={styles.loginForm}
//             initialValues={{ remember: true }}
//             onFinish={onFinish}
//             layout="vertical"
//           >
//             <Form.Item
//               name="username"
//               rules={[{ required: true, message: "សូមបញ្ចូលឈ្មោះអ្នកប្រើប្រាស់!" }]}
//             >
//               <Input
//                 prefix={<UserOutlined className={styles.inputIcon} />}
//                 placeholder="ឈ្មោះអ្នកប្រើប្រាស់ (Username)"
//                 value={usernameInput}
//                 onChange={(e) => setUsername(e.target.value)}
//                 className={styles.modernInput}
//               />
//             </Form.Item>

//             <Form.Item
//               name="password"
//               rules={[{ required: true, message: "សូមបញ្ចូលលេខសម្ងាត់របស់អ្នក!" }]}
//             >
//               <Input.Password
//                 prefix={<LockOutlined className={styles.inputIcon} />}
//                 placeholder="លេខសម្ងាត់ (Password)"
//                 value={passwordInput}
//                 onChange={(e) => setPassword(e.target.value)}
//                 className={styles.modernInput}
//               />
//             </Form.Item>

//             <Form.Item style={{ marginTop: 35 }}>
//               <Button
//                 type="primary"
//                 htmlType="submit"
//                 className={styles.modernSubmitBtn}
//                 block
//               >
//                 ចូលប្រើប្រាស់ប្រព័ន្ធ / Sign In
//               </Button>

//         <div
//   style={{
//     display: "flex",
//     justifyContent: "flex-end",
//     marginTop: "10px",
//     marginBottom: "15px",
//   }}
// >
//   <Text
//     onClick={() => navigate("/forgot-password")}
//     style={{
//       fontFamily: 'Content',
//       color: "red",
//       cursor: "pointer",
//     }}
//   >
//     ភ្លេចលេខសម្ងាត់?
//   </Text>
// </div>
//             </Form.Item>
//           </Form>

//           <div className={styles.loginFooter}>
//             <Text className={styles.footerText}>
//               © 2024 Votmean Mobile. All rights reserved.
//             </Text>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default LoginPage;

import React, { useState, useEffect } from "react";
import { LockOutlined, UserOutlined, CheckCircleFilled } from "@ant-design/icons";
import { Button, Form, Input, Typography, Divider, Card, Skeleton } from "antd";
import { useNavigate } from "react-router-dom";
import { request } from "../../share/request";
import { openNotification } from "../../share/message";
import QRCode from "qrcode";
import io from "socket.io-client";

import "../../styles/Home-module.css";
import styles from "./LoginPage.module.css";

const { Title, Text } = Typography;

const SOCKET_URL = "https://datacenterapi.votmean.app";

function LoginPage() {
  const navigate = useNavigate();
  const [usernameInput, setUsername] = useState("");
  const [passwordInput, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const [qrToken, setQrToken] = useState(null);
  const [qrImage, setQrImage] = useState(null);
  const [qrStatus, setQrStatus] = useState('waiting');
  const [qrLoading, setQrLoading] = useState(true);
  const [qrPollingInterval, setQrPollingInterval] = useState(null);
  const [qrExpiresIn, setQrExpiresIn] = useState(60);
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    generateQRCode();
    return () => {
      if (qrPollingInterval) clearInterval(qrPollingInterval);
      if (socket) socket.disconnect();
    };
  }, []);

  useEffect(() => {
    if (qrStatus === 'waiting' && qrExpiresIn > 0) {
      const timer = setInterval(() => {
        setQrExpiresIn(prev => {
          if (prev <= 1) {
            clearInterval(timer);
            setQrStatus('expired');
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [qrStatus, qrExpiresIn]);

  // ================================================================
  // REGULAR LOGIN
  // ================================================================

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const res = await request("user/login", "post", {
        username: usernameInput,
        password: passwordInput,
      });

      if (res.isSuccess) {
        if (res.profileData.islogin !== 0) {
          await saveLoginData(res);
          window.location.href = "/";
        } else {
          openNotification("error", "គណនីរបស់អ្នកត្រូវបានចាក់សោរ / Account Locked");
        }
      } else {
        openNotification("error", res.message || "ឈ្មោះអ្នកប្រើប្រាស់ ឬ លេខសម្ងាត់មិនត្រឹមត្រូវ");
      }
    } catch (error) {
      openNotification("error", "មានបញ្ហាតភ្ជាប់ទៅកាន់ប្រព័ន្ធ / Connection Error");
    } finally {
      setLoading(false);
    }
  };

  // ================================================================
  // SAVE LOGIN DATA (Same for both regular and QR login)
  // ================================================================

  const saveLoginData = (res) => {
    localStorage.setItem("profile", JSON.stringify(res.profileData));
    localStorage.setItem("profileOrgData", JSON.stringify(res.profileOrgData || {}));

    if (res.permission) {
      const encodedPermission = btoa(JSON.stringify(res.permission));
      localStorage.setItem("per_option", encodedPermission);
    }

    localStorage.setItem("token", res.access_token);
    localStorage.setItem("isLogin", "1");
  };

  // ================================================================
  // QR CODE LOGIN FUNCTIONS
  // ================================================================

  const generateQRCode = async () => {
    try {
      setQrLoading(true);
      setQrStatus('waiting');
      setQrImage(null);
      setQrExpiresIn(60);

      const token = localStorage.getItem('token');
      const response = await request(
        "auth/qr-login/generate",
        "post",
        {},
        token ? JSON.parse(token) : null
      );

      if (response.success) {
        setQrToken(response.login_token);
        setQrExpiresIn(60);

        const qrData = JSON.stringify({
          token: response.login_token,
          type: 'login',
          expires_at: response.expires_at
        });

        const qrDataURL = await QRCode.toDataURL(qrData, {
          width: 200,
          margin: 2,
          color: {
            dark: '#1e293b',
            light: '#ffffff'
          }
        });

        setQrImage(qrDataURL);
        connectWebSocket(response.login_token);
        startPolling(response.login_token);
      } else {
        openNotification("error", response.message || "មិនអាចបង្កើត QR Code បានទេ");
      }
    } catch (error) {
      console.error('Error generating QR:', error);
      openNotification("error", "មានបញ្ហាក្នុងការបង្កើត QR Code");
    } finally {
      setQrLoading(false);
    }
  };

  const connectWebSocket = (token) => {
    if (socket) socket.disconnect();

    const newSocket = io(SOCKET_URL, {
      query: { token: token },
      transports: ['websocket', 'polling']
    });

    newSocket.on('connect', () => {
      console.log('🔌 WebSocket connected for QR login');
      newSocket.emit('join_qr_room', token);
    });

    newSocket.on(`qr_login_scanned_${token}`, (data) => {
      console.log('📱 QR Code scanned by mobile:', data);
      setQrStatus('scanned');
    });

    // In LoginPage.js - WebSocket handler for QR login confirmed

    // When QR login is confirmed (web session created)
    newSocket.on(`qr_login_confirmed_${token}`, (data) => {
      console.log('✅ QR Login confirmed - Full Response:', data);

      // ✅ Check for isSuccess (same as login response)
      if (data.isSuccess) {
        setQrStatus('confirmed');

        // ✅ Save ALL data exactly like regular login
        if (data.profileData && data.access_token) {
          console.log('📝 Saving QR login data...');

          // Save profile data
          localStorage.setItem("profile", JSON.stringify(data.profileData));
          localStorage.setItem("profileOrgData", JSON.stringify(data.profileOrgData || {}));

          // Save permission
          if (data.permission) {
            const encodedPermission = btoa(JSON.stringify(data.permission));
            localStorage.setItem("per_option", encodedPermission);
          }

          // Save token and login status
          localStorage.setItem("token", data.access_token);
          localStorage.setItem("isLogin", "1");

          // ✅ Verify data was saved
          console.log('✅ Profile saved:', !!localStorage.getItem("profile"));
          console.log('✅ ProfileOrgData saved:', !!localStorage.getItem("profileOrgData"));
          console.log('✅ Permission saved:', !!localStorage.getItem("per_option"));
          console.log('✅ Token saved:', !!localStorage.getItem("token"));

          openNotification("success", "ចូលប្រើដោយជោគជ័យ! កំពុងប្តូរទៅកាន់ទំព័រ...");

          setTimeout(() => {
            window.location.href = "/";
          }, 1500);
        } else {
          console.error('❌ Missing profileData or access_token in response');
          openNotification("error", "មិនអាចទទួលបានទិន្នន័យអ្នកប្រើប្រាស់");
        }
      } else {
        console.error('❌ QR Login failed:', data);
        openNotification("error", data.message || "QR Login failed");
      }
    });

    newSocket.on('qr_login_expired', () => {
      setQrStatus('expired');
    });

    newSocket.on('disconnect', () => {
      console.log('🔌 WebSocket disconnected');
    });

    setSocket(newSocket);
  };

  // In LoginPage.js - Polling handler
  const startPolling = (token) => {
    if (qrPollingInterval) clearInterval(qrPollingInterval);

    const interval = setInterval(async () => {
      try {
        const response = await request(`auth/qr-login/status/${token}`, "get");

        console.log('📊 Polling response:', response);

        if (response.status === 'confirmed') {
          setQrStatus('confirmed');

          // ✅ If status returns full profile data (or we need to fetch it)
          if (response.profileData && response.access_token) {
            // Save all data
            localStorage.setItem("profile", JSON.stringify(response.profileData));
            localStorage.setItem("profileOrgData", JSON.stringify(response.profileOrgData || {}));

            if (response.permission) {
              const encodedPermission = btoa(JSON.stringify(response.permission));
              localStorage.setItem("per_option", encodedPermission);
            }

            localStorage.setItem("token", response.access_token);
            localStorage.setItem("isLogin", "1");

            openNotification("success", "ចូលប្រើដោយជោគជ័យ! កំពុងប្តូរទៅកាន់ទំព័រ...");

            setTimeout(() => {
              window.location.href = "/";
            }, 1500);
          } else if (response.session_token) {
            // Fallback: if only session_token, we need to fetch profile
            // Call the result endpoint to get full profile
            const resultResponse = await request(`auth/qr-login/result/${token}`, "get");
            if (resultResponse.isSuccess) {
              localStorage.setItem("profile", JSON.stringify(resultResponse.profileData));
              localStorage.setItem("profileOrgData", JSON.stringify(resultResponse.profileOrgData || {}));
              if (resultResponse.permission) {
                const encodedPermission = btoa(JSON.stringify(resultResponse.permission));
                localStorage.setItem("per_option", encodedPermission);
              }
              localStorage.setItem("token", resultResponse.access_token);
              localStorage.setItem("isLogin", "1");

              openNotification("success", "ចូលប្រើដោយជោគជ័យ! កំពុងប្តូរទៅកាន់ទំព័រ...");

              setTimeout(() => {
                window.location.href = "/";
              }, 1500);
            }
          }

          clearInterval(interval);
          setQrPollingInterval(null);
        } else if (response.status === 'scanned') {
          setQrStatus('scanned');
        } else if (response.status === 'expired') {
          setQrStatus('expired');
          clearInterval(interval);
          setQrPollingInterval(null);
        }
      } catch (error) {
        console.error('Error checking QR status:', error);
      }
    }, 3000);

    setQrPollingInterval(interval);
  };

  // ================================================================
  // RENDER QR CODE SECTION
  // ================================================================

  const renderQRCodeSection = () => {
    if (qrLoading) {
      return (
        <div style={{ textAlign: 'center', padding: '20px 0' }}>
          <Skeleton active paragraph={{ rows: 2 }} />
          <div style={{ marginTop: 12, display: 'flex', justifyContent: 'center' }}>
            <GetLoading />
          </div>
          <Text type="secondary" style={{ display: 'block', marginTop: 8, fontFamily: 'Content', }}>
            កំពុងបង្កើត QR Code...
          </Text>
        </div>
      );
    }

    if (qrStatus === 'confirmed') {
      return (
        <div style={{ textAlign: 'center', padding: '20px 0' }}>
          <div style={{
            width: 60, height: 60, borderRadius: 30,
            backgroundColor: '#dcfce7',
            display: 'flex', justifyContent: 'center', alignItems: 'center',
            margin: '0 auto 12px'
          }}>
            <CheckCircleFilled style={{ fontSize: 32, color: '#16a34a' }} />
          </div>
          <Text style={{ fontSize: 16, fontWeight: 600, color: '#16a34a', fontFamily: 'Content', }}>
            ចូលប្រើដោយជោគជ័យ!
          </Text>
          <Text type="secondary" style={{ display: 'block', marginTop: 4, fontFamily: 'Content', }}>
            កំពុងប្តូរទៅកាន់ទំព័រ...
          </Text>
        </div>
      );
    }

    if (qrStatus === 'scanned') {
      return (
        <div style={{ textAlign: 'center', padding: '20px 0', fontFamily: 'Content' }}>
          <div style={{
            width: 60, height: 60, borderRadius: 30,
            backgroundColor: '#dbeafe',
            display: 'flex', justifyContent: 'center', alignItems: 'center',
            margin: '0 auto 12px'
          }}>
            <span style={{ fontSize: 32 }}>📱</span>
          </div>
          <Text style={{ fontSize: 16, fontWeight: 600, color: '#3b82f6', fontFamily: 'Content', }}>
            បានស្កេន QR Code ហើយ!
          </Text>
          <Text type="secondary" style={{ display: 'block', marginTop: 4, fontFamily: 'Content', }}>
            កំពុងផ្ទៀងផ្ទាត់ពីទូរស័ព្ទ...
          </Text>
          <div style={{ marginTop: 12, display: 'flex', justifyContent: 'center' }}>
            <GetLoading />
          </div>
        </div>
      );
    }

    if (qrStatus === 'expired') {
      return (
        <div style={{ textAlign: 'center', padding: '16px 0' }}>
          <div style={{
            width: 60, height: 60, borderRadius: 30,
            backgroundColor: '#fee2e2',
            display: 'flex', justifyContent: 'center', alignItems: 'center',
            margin: '0 auto 12px'
          }}>
            <span style={{ fontSize: 32 }}>⏰</span>
          </div>
          <Text style={{ fontSize: 15, fontWeight: 600, color: '#dc2626', fontFamily: 'Content', }}>
            QR Code បានផុតកំណត់
          </Text>
          <Text type="secondary" style={{ display: 'block', marginTop: 4, fontSize: 13, fontFamily: 'Content', }}>
            សូមចុចបង្កើតថ្មីដើម្បីសាកល្បងម្តងទៀត
          </Text>
          <Button
            type="primary"
            size="small"
            style={{ marginTop: 12, backgroundColor: '#1e8449' }}
            onClick={generateQRCode}
          >
            បង្កើតថ្មី
          </Button>
        </div>
      );
    }

    // Waiting state - Show QR Code
    return (
      <div style={{ textAlign: 'center', fontFamily: 'Content', color: '#085fe9ff' }}>
        {qrImage && (
          <div style={{

            background: '#ffffff', padding: 12, borderRadius: 12,
            display: 'inline-block',
            border: '2px solid #e8f5e9',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
          }}>
            <img src={qrImage} alt="QR Code" style={{ width: 180, height: 180 }} />
          </div>
        )}

        <div style={{ marginTop: 10 }}>
          <Text style={{ display: 'block', fontSize: 14, fontWeight: 500, color: '#1e293b', fontFamily: 'Content', }}>
            📱 ស្កេន QR Code ដោយប្រើទូរស័ព្ទ
          </Text>
          <Text type="secondary" style={{ display: 'block', fontSize: 12, marginTop: 2, fontFamily: 'Content', }}>
            បើកកម្មវិធី Votmean Mobile ហើយស្កេន
          </Text>
          <div style={{ marginTop: 8 }}>
            <Text type="secondary" style={{ fontSize: 12, fontFamily: 'Content', }}>
              ⏱️ ផុតកំណត់ក្នុង {Math.floor(qrExpiresIn / 60)}:{String(qrExpiresIn % 60).padStart(2, '0')}
            </Text>
            <Button
              type="link"
              size="small"
              style={{ marginLeft: 8, color: '#1e8449' }}
              onClick={generateQRCode}
            >
              បង្កើតថ្មី
            </Button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.loginWrapper}>
      {loading && (
        <div className={styles.loadingOverlay}>
          <GetLoading />
        </div>
      )}

      <div className={styles.loginContainer}>
        {/* COLUMN 1: Details */}
        <div className={styles.detailsColumn}>
          <div className={styles.brandHeader}>
            <img
              src="https://datacenterapi.votmean.app/photo/hmis_staff/file_image_logo-1763183005047-108934296"
              alt="Logo"
              className={styles.infoLogo}
            />
            <div>
              <Title level={2} className={styles.infoMainTitle}>វត្តមាន Votmean</Title>
              <Text className={styles.infoSubTitle}>VOTMEAN APP MANAGEMENT SYSTEM</Text>
            </div>
          </div>
          <div className={styles.featureList}>
            <Title level={4} className={styles.featureSectionTitle}>
              មុខងារ និងការគ្រប់គ្រងប្រព័ន្ធលម្អិត
            </Title>
            <div className={styles.featureItem}>
              <CheckCircleFilled className={styles.featureIcon} />
              <div>
                <Text className={styles.featureTitle}>គ្រប់គ្រងតាមអង្គភាពនីមួយៗ</Text>
                <Text className={styles.featureDesc}>រៀបចំរចនាសម្ព័ន្ធ កំណត់តួនាទី និងសិទ្ធិប្រើប្រាស់ទៅតាមនាយកដ្ឋាន ឬផ្នែកនីមួយៗដាច់ដោយឡែក ប្រកបដោយសុវត្ថិភាព។</Text>
              </div>
            </div>
            <div className={styles.featureItem}>
              <CheckCircleFilled className={styles.featureIcon} />
              <div>
                <Text className={styles.featureTitle}>ស្រង់វត្តមានបុគ្គលិកឆ្លាតវៃ</Text>
                <Text className={styles.featureDesc}>កត់ត្រាទិន្នន័យវត្តមាន ម៉ោងចូល និងម៉ោងចេញយ៉ាងត្រឹមត្រូវរហ័ស ទប់ស្កាត់ការក្លែងបន្លំទិន្នន័យ។</Text>
              </div>
            </div>
            <div className={styles.featureItem}>
              <CheckCircleFilled className={styles.featureIcon} />
              <div>
                <Text className={styles.featureTitle}>របាយការណ៍តាម Web App & Phone</Text>
                <Text className={styles.featureDesc}>ពិនិត្យមើល និងទាញយករបាយការណ៍វត្តមាន និងស្ថិតិផ្សេងៗបានទាន់ពេលវេលា (Real-time) ទាំងនៅលើកុំព្យូទ័រ និងទូរស័ព្ទដៃ។</Text>
              </div>
            </div>
            <div className={styles.featureItem}>
              <CheckCircleFilled className={styles.featureIcon} />
              <div>
                <Text className={styles.featureTitle}>គ្រប់គ្រងការចុះបេសកកម្ម និងច្បាប់ឈប់សម្រាក</Text>
                <Text className={styles.featureDesc}>ស្នើសុំ និងអនុម័តច្បាប់ឈប់សម្រាក (Leave Request) ឬលិខិតបញ្ជាបេសកកម្មផ្សេងៗតាមរយៈប្រព័ន្ធឌីជីថលទំនើប។</Text>
              </div>
            </div>
            <div className={styles.featureItem}>
              <CheckCircleFilled className={styles.featureIcon} />
              <div>
                <Text className={styles.featureTitle}>មុខងារកំណត់សិទ្ធអ្នកប្រើប្រាស់</Text>
                <Text className={styles.featureDesc}>ប្រព័ន្ធគ្រប់គ្រងសិទ្ធអ្នកប្រើប្រាស់ដូចការ បង្កើត កែប្រែ លុប</Text>
              </div>
            </div>
            <div className={styles.featureItem}>
              <CheckCircleFilled className={styles.featureIcon} />
              <div>
                <Text className={styles.featureTitle}>កំណត់មុខងារផ្សេងៗ</Text>
                <Text className={styles.featureDesc}>ប្រព័ន្ធគ្រប់គ្រងការ ផ្ញើរសារទៅកាន់ Mobile App WebApp Telegram..</Text>
              </div>
            </div>
          </div>
        </div>

        {/* COLUMN 2: Login Form with Auto QR Code */}
        <div className={styles.formColumn}>
          <div className={styles.formHeaderSection}>
            <Title level={3} className={styles.khmerTitle}>ស្វាគមន៍មកកាន់ប្រព័ន្ធ</Title>
            <Text className={styles.formSubTitle}>សូមបញ្ចូលគណនីរបស់អ្នកដើម្បីចូលប្រើប្រាស់</Text>
          </div>

          <Form name="login_form" className={styles.loginForm} onFinish={onFinish} layout="vertical">
            <Form.Item
              name="username"
              rules={[{ required: true, message: "សូមបញ្ចូលឈ្មោះអ្នកប្រើប្រាស់!" }]}
            >
              <Input
                prefix={<UserOutlined className={styles.inputIcon} />}
                placeholder="ឈ្មោះអ្នកប្រើប្រាស់ (Username)"
                value={usernameInput}
                onChange={(e) => setUsername(e.target.value)}
                className={styles.modernInput}
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: "សូមបញ្ចូលលេខសម្ងាត់របស់អ្នក!" }]}
            >
              <Input.Password
                prefix={<LockOutlined className={styles.inputIcon} />}
                placeholder="លេខសម្ងាត់ (Password)"
                value={passwordInput}
                onChange={(e) => setPassword(e.target.value)}
                className={styles.modernInput}
              />
            </Form.Item>

            <Form.Item style={{ marginTop: 20 }}>
              <Button type="primary" htmlType="submit" className={styles.modernSubmitBtn} block>
                ចូលប្រើប្រាស់ប្រព័ន្ធ / Sign In
              </Button>
            </Form.Item>
          </Form>

          <div style={{ display: "flex", justifyContent: "center", marginTop: 12 }}>
            <Text onClick={() => navigate("/forgot-password")} style={{ fontFamily: 'Content', color: "#dc2626", cursor: "pointer", fontSize: 14 }}>
              ភ្លេចលេខសម្ងាត់?
            </Text>
          </div>

          <div className={styles.loginFooter}>
            <Text className={styles.footerText}>© 2024 Votmean Mobile. All rights reserved.</Text>
          </div>
        </div>

        {/* COLUMN 3: QR Code Section */}
        <div className={styles.qrColumn}>
          <div style={{ textAlign: "center", marginBottom: 16 }}>
            <Title level={4} style={{ fontFamily: "Content", color: "#1e293b", margin: 0 }}>ឬចូលប្រើដោយ QR Code</Title>
            <Text type="secondary" style={{ fontFamily: "Content", fontSize: 12 }}>សុវត្ថិភាព និងលឿនរហ័ស</Text>
          </div>
          <Card size="small" style={{ fontFamily: 'Content', borderRadius: 12, borderColor: '#e8f5e9', backgroundColor: '#ffffff', marginBottom: 12, boxShadow: '0 4px 12px rgba(0,0,0,0.03)' }}>
            {renderQRCodeSection()}
          </Card>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;